var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47043 0.330616C7.79449 0.1283 8.20551 0.1283 8.52957 0.330616L10.4913 1.55531C10.585 1.61384 10.6878 1.65642 10.7955 1.68132L13.0486 2.20246C13.4208 2.28855 13.7114 2.57919 13.7975 2.95139L14.3187 5.20451C14.3436 5.31218 14.3862 5.41499 14.4447 5.50873L15.6694 7.47043C15.8717 7.79449 15.8717 8.20551 15.6694 8.52958L14.4447 10.4913C14.3862 10.585 14.3436 10.6878 14.3187 10.7955L13.7975 13.0486C13.7114 13.4208 13.4208 13.7114 13.0486 13.7975L10.7955 14.3187C10.6878 14.3436 10.585 14.3862 10.4913 14.4447L8.52957 15.6694C8.20551 15.8717 7.79449 15.8717 7.47043 15.6694L5.50873 14.4447C5.41499 14.3862 5.31218 14.3436 5.20451 14.3187L2.95139 13.7975C2.57918 13.7114 2.28855 13.4208 2.20246 13.0486L1.68132 10.7955C1.65642 10.6878 1.61384 10.585 1.55531 10.4913L0.330616 8.52957C0.1283 8.20551 0.1283 7.79449 0.330616 7.47043L1.55531 5.50873C1.61384 5.41499 1.65642 5.31218 1.68132 5.20451L2.20246 2.95139C2.28855 2.57918 2.57919 2.28855 2.95139 2.20246L5.20451 1.68132C5.31218 1.65642 5.41499 1.61384 5.50873 1.55531L7.47043 0.330616Z",
    fill: "#38B048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3476 5.77824L7.31334 10.2068L5.0077 8.2948",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.2545a544.svg";
export { ForwardRef as ReactComponent };